/***************************************************************************
 * The contents of this file were generated with Amplify Studio.           *
 * Please refrain from making any modifications to this file.              *
 * Any changes to this file will be overwritten when running amplify pull. *
 **************************************************************************/

/* eslint-disable */
import * as React from "react";
import {
  getOverrideProps,
  getOverridesFromVariants,
  mergeVariantsAndOverrides,
} from "@aws-amplify/ui-react/internal";
import { Flex, Text } from "@aws-amplify/ui-react";
export default function CommonBtnRound(props) {
  const { overrides: overridesProp, ...rest } = props;
  const variants = [
    {
      overrides: { text: {}, CommonBtnRound: {} },
      variantValues: { color: "Gray" },
    },
    {
      overrides: {
        text: {},
        CommonBtnRound: { backgroundColor: "rgba(255,255,255,1)" },
      },
      variantValues: { color: "White" },
    },
    {
      overrides: {
        text: {},
        CommonBtnRound: { backgroundColor: "rgba(220,220,220,1)" },
      },
      variantValues: { color: "Hover" },
    },
  ];
  const overrides = mergeVariantsAndOverrides(
    getOverridesFromVariants(variants, props),
    overridesProp || {}
  );
  return (
    <Flex
      gap="10px"
      direction="row"
      width="unset"
      height="unset"
      justifyContent="center"
      alignItems="center"
      position="relative"
      borderRadius="15px"
      padding="8px 16px 8px 16px"
      backgroundColor="rgba(245,245,245,1)"
      display="flex"
      {...rest}
      {...getOverrideProps(overrides, "CommonBtnRound")}
    >
      <Text
        fontFamily="Noto Sans"
        fontSize="14px"
        fontWeight="400"
        color="rgba(53,56,59,1)"
        lineHeight="14px"
        textAlign="left"
        display="block"
        direction="column"
        justifyContent="unset"
        letterSpacing="0.55px"
        width="unset"
        height="unset"
        gap="unset"
        alignItems="unset"
        shrink="0"
        position="relative"
        padding="0px 0px 0px 0px"
        whiteSpace="pre-wrap"
        children="Button Text"
        {...getOverrideProps(overrides, "text")}
      ></Text>
    </Flex>
  );
}
